<template>
    <div>
    </div>
</template>

<script>
    export default {
        props: {
            idPrefix: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
            };
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/cinemas/CityCinemaFilters.vue